import React from "react";
import {
    Box,
    Drawer,
    DrawerBody,
    DrawerContent,
    DrawerOverlay,
    Icon,
    IconButton,
    Stack,
    Text,
} from "@chakra-ui/react";
import { MdClose, MdReceiptLong } from "react-icons/md";
import UserInvoicesList from "./UserInvoicesList";

const drawerContentProps = {
    background: "rgba(20, 20, 20, 0.96)",
    backdropFilter: "blur(20px)",
    borderLeft: "1px solid rgba(255, 255, 255, 0.12)",
    color: "rgba(255, 255, 255, 0.9)",
};

const drawerBodyProps = {
    p: 5,
    display: "flex",
    flexDirection: "column",
    gap: 5,
};

const iconBadgeProps = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "32px",
    height: "32px",
    borderRadius: "8px",
    background: "rgba(23, 220, 184, 0.15)",
    border: "1px solid rgba(23, 220, 184, 0.3)",
    boxShadow: "0 2px 8px rgba(23, 220, 184, 0.2)",
};

/**
 * Drawer header with the icon badge, title, subtitle and a close button.
 * @param {Object} props
 * @param {Function} props.onClose - Close callback
 * @returns {React.ReactElement}
 */
function DrawerHeaderRow({ onClose }) {
    return (
        <Box pb={3} borderBottom="1px solid rgba(255, 255, 255, 0.08)">
            <Stack direction="row" alignItems="center" justifyContent="space-between">
                <Stack direction="row" spacing={2} alignItems="center">
                    <Box {...iconBadgeProps}>
                        <Icon as={MdReceiptLong} color="#17dcb8" boxSize="18px" />
                    </Box>
                    <Stack spacing={0.5}>
                        <Text color="rgba(255, 255, 255, 0.95)" fontSize="0.9rem" fontWeight={600} letterSpacing="0.3px">
                            Historique de facturation
                        </Text>
                        <Text color="rgba(255, 255, 255, 0.55)" fontSize="0.7rem">
                            Toutes les factures Stripe de l'utilisateur
                        </Text>
                    </Stack>
                </Stack>
                <IconButton aria-label="Fermer" onClick={onClose} size="sm" variant="ghost"
                    color="rgba(255, 255, 255, 0.7)" icon={<Icon as={MdClose} boxSize="18px" />} />
            </Stack>
        </Box>
    );
}

/**
 * Right-side drawer that displays the aggregated invoice history for a user.
 * @param {Object} props
 * @param {boolean} props.open - Whether the drawer is open
 * @param {number|string|null} props.userId - Target user ID (only fetched while open)
 * @param {Function} props.onClose - Close callback
 * @returns {React.ReactElement}
 */
function UserInvoicesDrawer({ open, userId, onClose }) {
    return (
        <Drawer isOpen={open} onClose={onClose} placement="right" size="md">
            <DrawerOverlay />
            <DrawerContent {...drawerContentProps}>
                <DrawerBody {...drawerBodyProps}>
                    <DrawerHeaderRow onClose={onClose} />
                    {open && <UserInvoicesList userId={userId} />}
                </DrawerBody>
            </DrawerContent>
        </Drawer>
    );
}

export default UserInvoicesDrawer;
